/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VinInfo,
    VinInfoFromJSON,
    VinInfoFromJSONTyped,
    VinInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface VinInfoResponse
 */
export interface VinInfoResponse {
    /**
     * 
     * @type {Array<VinInfo>}
     * @memberof VinInfoResponse
     */
    all: Array<VinInfo>;
    /**
     * 
     * @type {number}
     * @memberof VinInfoResponse
     */
    totalCount: number;
}

export function VinInfoResponseFromJSON(json: any): VinInfoResponse {
    return VinInfoResponseFromJSONTyped(json, false);
}

export function VinInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VinInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all': ((json['all'] as Array<any>).map(VinInfoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function VinInfoResponseToJSON(value?: VinInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all': ((value.all as Array<any>).map(VinInfoToJSON)),
        'totalCount': value.totalCount,
    };
}


